import { render, staticRenderFns } from "./VDNavbar.vue?vue&type=template&id=2d7ee034&"
import script from "./VDNavbar.vue?vue&type=script&lang=js&"
export * from "./VDNavbar.vue?vue&type=script&lang=js&"
import style0 from "./VDNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports